module.exports = __webpack_public_path__ + "images/CC_Incorrect.png";